/*
  法语（fr）
*/
export default {
  headerBar: {
    allProducts: 'Tous les produits',
    newIn: 'Nouvelle entrée',
    bestSellers: 'Best - seller',
    specialOffer: 'Offres spéciales',
    explore: 'Exploration',
    fashionTrends: 'Tendances de la mode',
    whyUs: 'Pourquoi nous?',
    helpCenter: "Centre d'assistance",
    company: 'Entreprises',
    dropshipping: 'Livraison directe',
    aboutUs: 'À propos de nous',
    blog: 'Blogs',
    login: 'Nom de connexion',
    register: 'Inscription gratuite',
    searchingFor: 'Recherche en cours',
    wishList: 'Liste des souhaits',
    listing: 'Table Book',
    allOrder: 'Toutes les commandes',
    accountSetting: 'Configuration du compte',
    logOut: 'Passation par profits et pertes',
    home: 'La maison',
    startSelling: 'Commencer à vendre',
    wholesale: 'Commerce de gros'
  },
  indexPage: {
    hello: 'Bonjour',
    allCategory: 'Toutes catégories',
    apparelWholesale: 'Commerce de gros de vêtements',
    smartDropshiping: 'Glisser - déposer intelligent',
    smallMOQCustomization: 'Petite personnalisation MOQ',
    fastWorldwideShipping: 'Livraison rapide dans le monde entier',
    estimateShippingCost: 'Coût estimatif du transport',
    flashSale: 'Vente éclair',
    customization: 'Personnalisation',
    customizationText1: 'Avec plus de 500 fournisseurs et plus de 100 designers,',
    customizationText2: 'Les produits exclusifs ne peuvent être personnalisés que pour vous.',
    ins: 'Sélection des influenceurs',
    insText1: 'Les dernières tendances de la mode pour obtenir des vêtements inspo.',
    insText2: 'Offrez le même design pour vos ventes.',
    youMayLike: 'Ça pourrait te plaire.',
    viewMore: "Voir plus d'informations"
  }
}
